import { client } from "Service/axios";
import { HINTS } from "Shared/Constants/apiRequest";
import { HintsTypeByGet, IHints } from "Shared/Types/hints";

class Hints {
  getHints(params: IHints | null) {
    return client.get<HintsTypeByGet>(HINTS, { params });
  }
}

export default Hints;
